import { ConfigType } from "../../abstract/Form";
import { SelectFormInputOption } from "../../components/inputs/SelectFormInput";
import { EthnicityType } from "../../types";
import { infertilityDiagnosisOptions, conditionOptions } from "./types";

export const config: ConfigType = {
    right: [
        {
            label: "Patient Background",
            rows: [
                {
                    fields: [
                        {
                            name: "name",
                            label: "Name",
                            type: "text",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "birth",
                            label: "Date of Birth",
                            type: "date",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "height",
                            label: "Height",
                            type: "height",
                            required: true,
                        },
                        {
                            name: "weight",
                            label: "Weight",
                            type: "weight",
                            required: true,
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "ethnicity",
                            label: "Ethnicity",
                            type: "tag-select",
                            required: true,
                            options: Object.keys(EthnicityType).map(key => ({
                                label: EthnicityType[key as keyof typeof EthnicityType].toString(),
                                value: key
                            }))
                        },
                    ]
                }

            ]
        },
        {
            label: "Medical History",
            rows: [
                {
                    fields: [
                        {
                            name: "infertilityDiagnosis",
                            label: "Primary infertility diagnosis",
                            type: "select",
                            required: true,
                            options: infertilityDiagnosisOptions
                        },


                    ]
                },
                {
                    fields: [
                        {
                            name: "conditions",
                            label: "Relevant medical conditions",
                            type: "checkboxes",
                            required: true,
                            options: conditionOptions as SelectFormInputOption[]
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "currentMedication",
                            label: "Current medication",
                            type: "text",
                            required: true,
                        },
                    ]
                }
            ]

        },

        {
            label: "Ovarian Reserve Markers",
            subsections: [
                {
                    label: "AMH, FSH, & Estradiol Level",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "amh.value",
                                    label: "AMH Level",
                                    type: "number",
                                    required: true,
                                    adornment: "ng/mL"
                                },
                                {
                                    name: "amh.date",
                                    label: "AMH test date",
                                    type: "date",
                                    required: true
                                },

                            ]
                        },
                        {
                            fields: [

                                {
                                    name: "fsh.value",
                                    label: "Day 3 FSH Level",
                                    type: "number",
                                    required: true,
                                    adornment: "mIU/mL"
                                },
                                {
                                    name: "fsh.date",
                                    label: "FSH test date",
                                    type: "date",
                                    required: true
                                },
                            ]
                        },
                        {
                            fields: [
                                {
                                    name: "estradiol.value",
                                    label: "Day 3 estradiol Level",
                                    type: "number",
                                    required: true
                                },
                                {
                                    name: "estradiol.date",
                                    label: "Estradiol test date",
                                    type: "date",
                                    required: true
                                },

                            ]
                        }
                    ]
                },
                {
                    label: "AFC",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "afc.right.date",
                                    label: "Right overy",
                                    type: "date",
                                    required: true
                                },
                                {
                                    name: "afc.left.date",
                                    label: "Left overy",
                                    type: "date",
                                    required: true
                                },
                            ]
                        },
                        {
                            fields: [
                                {
                                    name: "agc.ultrasound.date",
                                    label: "AFC ultrasound date",
                                    type: "date",
                                    required: true
                                },
                            ]
                        }
                    ]
                }
            ]
        },

        {
            label: "Partner Information",
            subsections: [
                {
                    label: "",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "partner.age",
                                    label: "Partner's age",
                                    type: "number",
                                    required: true
                                },
                                {
                                    name: "partner.birth",
                                    label: "Date of Birth",
                                    type: "date",
                                    required: true
                                },
                            ]
                        }
                    ]
                },
                {
                    label: "Most Recent Semen Analysis",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "semenAnalysis.date",
                                    label: "Date of analysis",
                                    type: "date",
                                    required: true
                                },

                            ]
                        },
                        {
                            fields: [
                                {
                                    name: "semenAnalysis.count",
                                    label: "Sperm count",
                                    type: "number",
                                    required: true
                                },
                                {
                                    name: "semenAnalysis.motility",
                                    label: "Motility",
                                    type: "number",
                                    required: true
                                },
                                {
                                    name: "semenAnalysis.morphology",
                                    label: "Morphology",
                                    type: "number",
                                    required: true
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            label: "Genetic Screening",
            rows: [
                {
                    fields: [
                        {
                            name: "carrierScreening",
                            label: "Carrier screening performed?",
                            type: "button-selection",
                            options: [
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" }
                            ],
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "pgt",
                            label: "Preimplantation genetic testing planned?",
                            type: "button-selection",
                            options: [
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" }
                            ],
                            required: true
                        },
                    ]

                }
            ]
        },
        {
            label: "Uterine Assessment",
            rows: [
                {
                    fields: [
                        {
                            name: "endometrialThickness",
                            label: "Endometrial thickness at last measurement",
                            type: "number",
                            required: true
                        },
                        {
                            name: "dateOfMeasurement",
                            label: "Date of measurement",
                            type: "number",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "uterineAnomalies",
                            label: "Uterine anomalies",
                            type: "select",
                            required: true,
                            options: [
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" }
                            ]
                        },
                    ]
                }
            ],
        },
        {
            label: "Treatment Goals",
            rows: [
                {
                    fields: [
                        {
                            name: "oocytes.count",
                            label: "Desired number of oocytes",
                            type: "number",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "uterineAnomalies",
                            label: "Fresh transfer planned?",
                            type: "button-selection",
                            required: true,
                            options: [
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" }
                            ]
                        },
                    ]
                }
            ],
        },
        {
            label: "Special Condciderations",
            rows: [
                {
                    fields: [
                        {
                            name: "allergies",
                            label: "Any known allergies to medications",
                            type: "text",
                            multiline: true,
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "religios",
                            label: "Any religious or cultural considerations for treatment",
                            type: "text",
                            required: true,
                            multiline: true,
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "financial",
                            label: "Any financial constraints to consider",
                            type: "text",
                            required: true,
                            multiline: true,
                        },
                    ]
                }
            ],
        },
        {
            label: "Clinicial Notes",
            rows: [
                {
                    fields: [
                        {
                            name: "additionalInformation",
                            label: "Additional relevant information",
                            type: "text",
                            multiline: true,
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "proposedProtocolModifications",
                            label: "Proposed protocol modifications",
                            type: "text",
                            required: true,
                            multiline: true,
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "financial",
                            label: "Any financial constraints to consider",
                            type: "text",
                            required: true,
                            multiline: true,
                        },
                    ]
                }
            ],
        }


    ], left: []
};
